import { useDeployProcess } from "./useDeployProcess";

export const useCanEditAndSendDeploy = () => {
  const deployProcess = useDeployProcess();
  return deployProcess === "edit_and_send";
};
